<div id="content" class="mb-0">
  <img
      src="../../assets/dummy/chatbot_v3.png"
      alt="Digitaler assistent">
  <div class="widget">
    <h2 class="pb-s">Kennen Sie schon unseren Digitalen Assistenten?</h2>
    <p>
      Um Ihnen längere Wartezeiten am Telefon zu ersparen und für bestimmte Anliegen 24/7 erreichbar zu sein, haben wir eine Digitale Assistenz für Sie eingeführt. Damit können Sie die folgenden Anliegen eigenständig und ohne Verzögerung abwickeln
    </p>
    <div class="text-center">
      <img class="img-fluid w-50" src="../../assets/dummy/chatbot-video.png" alt="">
    </div>
    <h2 class="pb-s mt-l text-center">Die Funktionen im Überblick:</h2>
    <div class="text-center">
      <img class="img-fluid w-75" src="../../assets/dummy/chat-2.png" alt="">
    </div>
    <h2 class="pb-s mt-l text-center">Wählen Sie Ihren Wunschkanal:</h2>
    <div class="text-center">
      <img class="img-fluid w-75" src="../../assets/dummy/chat-3.png" alt="">
    </div>
    <h2 class="pb-s mt-l">Vorteile:</h2>
    <ul>
      <li>24/7 Erreichbarkeit</li>
      <li>Sie erhalten direkt eine Auskunft bzw. Bestätigung</li>
      <li>Kostenfrei & ohne Wartezeit</li>
    </ul>

    <p>
      Unser Kundenservice steht Ihnen natürlich weiterhin zu den gewohnten Öffnungszeiten zur Verfügung.<br> (Montag bis Freitag 08:30 – 18:30 Uhr & Samstag 09:00 – 12:00 Uhr)
    </p>
 </div>
</div>
<section class="green-square">
  <h2>Telefonisch oder via Chatfunktion:</h2>
  <a>
    <button class="btn-primary on-dark-bg mr-l">
      0800 104 9999
    </button>
  </a>
  <a>
    <button class="btn-primary on-dark-bg mr-l">
      Zum chat auf dem dashboard
    </button>
  </a>
</section>
